export const supportedSportTypeGenders = (sport) => {
	const supported = ['lacrosse']

	return supported.some(s => s === sport.toLowerCase())
}

export const supportedTeamTypes = (sport) => {
	// in the future can be extended for different sport types with other params
	const supported = ['american_football']

	return supported.some(s => s === sport.toLowerCase())
}

export const supportedSportTypeVidswap = (sport) => {
	if (!sport) {
		return []
	}
	const supported = ['soccer', 'basketball', 'volleyball', 'baseball', 'softball', 'lacrosse', 'lacrosse-men', 'lacrosse-women', 'hockey', 'fieldhockey', 'flag-football', 'canadian-football', 'outdoor-football', 'american_football']

	return supported.some(s => s === sport.toLowerCase())
}

const getCurrencySign = (currency) => {
	switch (currency && currency.toLowerCase()) {
			case 'eur':
				return '€'
			case 'gbp':
				return '£'
			case 'usd':
			default:
				return '$'
	}
}

export const formatCurrency = (price, curr = null, decimal = 0) => {
	const currency = getCurrencySign(curr)
	const fixedPrice = Number(price || 0).toFixed(decimal)

	return `${currency}${fixedPrice}`
}

const parseDate = (parsedDate, isUnix = true) => {
	const dateString = isNaN(Number(parsedDate)) ? parsedDate : Number(parsedDate)

	return typeof dateString === 'string'
		? new Date(dateString)
		: typeof dateString === 'number'
			? new Date(dateString * (isUnix ? 1000 : 1))
			: dateString
}

export const formatDate = (dateString, type = 'short') => {
	const date = parseDate(dateString)

	if (!date) {
		return '---'
	}

	switch (type) {
			case 'short':
				return `${date.toLocaleString('en-En', { month: 'short' })} ${date.getDate()}, ${date.getFullYear()}`
			case 'long':
				return `${date.toLocaleString('en-En', { weekday: 'short' })} ${date.getDate()}, ` +
      `${date.toLocaleString('en-En', { month: 'short' })} ${date.getFullYear()}`
	}
}

export const formatDateToUnix = (dateString) => {
	const date = parseDate(dateString, false)

	return Math.round(date.getTime() / 1000).toString()
}

export const getParsedUnixDateRange = (startDateString, endDateString) => {
	const start = Number(startDateString)
	const end = Number(endDateString)

	if (!start || !end) {
		return []
	}

	return [parseDate(start), parseDate(end)]
}

export const capitalize = (str) => {
	return str && str.charAt(0).toUpperCase() + str.slice(1)
}

export const getTokenFromHashQuery = (hash) => {
	return new URLSearchParams(hash.substring(1)).get('token')
}

export function removeEmojis (string) {
	// https://www.multimediaxp.com/post/78/how-to-allow-block-emojis-emoticons-in-html-forms
	/* eslint-disable-next-line unicorn/escape-case */
	const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
	return string.replace(regex, '')
}

export function hasNonASCIISymbols (str) {
	/* eslint-disable-next-line no-control-regex */
	const regex = /[^\x00-\x7F]/

	return regex.test(str)
}
